import React from 'react';
import { Body1 } from '@xo-union/tk-ui-typography';

import { StatusText } from '../Card';
import styles from './styles.scss';
import QuestionSubText from './QuestionSubText';
import QuestionList from './QuestionList';
import { WeddingWebsiteQuery } from '../../generated/graphql';
import { EventType } from '../WeddingPageCard/EventItem';
import { GuestWeddingQuestions } from './QuestionList';
import AddGuestText from './AddGuestText';
import { EventRsvpDataQuery } from '../../generated/graphql';

interface Props {
  guestWedding: WeddingWebsiteQuery['guestWedding'];
  events: EventType[];
  rsvpData: NonNullable<NonNullable<EventRsvpDataQuery['eventRsvpData']>[0]>[] | null;
}

const InactiveRsvpCard: React.FC<Props> = ({ guestWedding, events, rsvpData }) => {
  const isPrivateRsvp = guestWedding?.isPrivateRsvp;
  return (
    <>
      <div className={styles.cardSection}>
        {events?.length &&
          events.map((event: EventType) => {
            const { requireRsvp } = event;
            const eventRsvpData = rsvpData?.find(eventRsvpData => eventRsvpData.eventId === event.id);
            const guestCount = eventRsvpData?.guestCount || 0;
            return (
              <div key={event.id} className={styles.linedCardSection}>
                <Body1 bold className={styles.questionSubhead}>
                  {event.name}
                  {!requireRsvp && <StatusText className={styles.marginLeftMd}>Not Collecting RSVPs</StatusText>}
                </Body1>
                {requireRsvp && (
                  <>
                    <AddGuestText
                      isPrivateRsvp={isPrivateRsvp || null}
                      event={event}
                      guestCount={guestCount}
                      rsvpData={rsvpData}
                    />
                    {!!event?.questions?.length && (
                      <QuestionList questions={event.questions as GuestWeddingQuestions} />
                    )}
                  </>
                )}
              </div>
            );
          })}

        <div className={styles.linedCardSection}>
          <Body1 bold className={styles.questionSubhead}>
            General Questions
          </Body1>
          <QuestionSubText
            privateRsvp={isPrivateRsvp || null}
            hasQuestions={!!guestWedding?.questions && !!guestWedding.questions.length}
          />
          {guestWedding?.questions?.length && (
            <QuestionList questions={guestWedding?.questions as GuestWeddingQuestions} />
          )}
        </div>
      </div>
    </>
  );
};

export default InactiveRsvpCard;
